import {Toolbar} from "./Toolbar.js";

export class CanvasEditor {
	/**
	 * @param {string} canvasId - ID of <canvas> element
	 */
	constructor(canvasId) {
		/** @type {HTMLCanvasElement} */
		this.domCanvas = document.getElementById(canvasId);
		this.initSize(this.domCanvas.width, this.domCanvas.height);

		this.willUpdate = false;
		/** @type {Toolbar} */
		this.toolbar = null;
		/** @type {Canvas} */
		this.canvas = null;
	}

	initSize(logicalWidth, logicaHeight) {
		this.pixel = window.devicePixelRatio;

		this.domCanvas.style.width = logicalWidth + "px";
		this.domCanvas.style.height = logicaHeight + "px";

		this.domCanvas.width = logicalWidth * this.pixel;
		this.domCanvas.height = logicaHeight * this.pixel;
	}

	init() {
		this.toolbar = this.createToolbar();
		this.canvas = this.createCanvas();
		this.update();
		this.domCanvas.addEventListener("mousedown", this.mouseDown.bind(this));
		this.domCanvas.addEventListener("mouseup", this.mouseUp.bind(this));
		this.domCanvas.addEventListener("mousemove", this.mouseMove.bind(this));
		this.domCanvas.addEventListener("wheel", this.wheel.bind(this));
		this.domCanvas.addEventListener("dblclick", this.doubleClick.bind(this));
		this.domCanvas.addEventListener("keydown", this.keyDown.bind(this));
	}

	mouseEvent(e, tool) {
		const cursor = tool.getCursor();
		if (cursor !== null) this.domCanvas.style.cursor = cursor;
	}

	mouseDown(e) {
		if (this.toolbar.in(e)) {
			if (this.toolbar.mouseDown(e)) this.update();
		} else {
			let tool = this.toolbar.currentTool;
			if (tool.mouseDown(e, this.canvas)) this.update();
			this.mouseEvent(e, tool);
		}
	}

	mouseUp(e) {
		if (this.toolbar.in(e)) {
			if (this.toolbar.mouseUp(e)) this.update();
		} else {
			let tool = this.toolbar.currentTool;
			if (tool.mouseUp(e, this.canvas)) this.update();
			this.mouseEvent(e, tool);
		}
	}

	mouseMove(e) {
		if (this.toolbar.in(e)) {
			if (this.toolbar.mouseMove(e)) this.update();
		} else {
			let tool = this.toolbar.currentTool;
			if (tool.mouseMove(e, this.canvas)) this.update();
			this.mouseEvent(e, tool);
		}
	}

	doubleClick(e) {
		if (this.toolbar.in(e)) {

		} else {
			let tool = this.toolbar.currentTool;
			if (tool.doubleClick(e, this.canvas)) this.update();
		}
	}

	keyDown(e) {
		if (e.keyCode === 8 || e.keyCode === 46) {
			e.preventDefault();
			this.delete(e);
		}
	}


	delete(e) {
	}


	wheel(e) {
		e.preventDefault();
		this.canvas.scrollX -= e.deltaX;
		this.canvas.scrollY -= e.deltaY;
		this.update();
	}

	update() {
		if (!this.willUpdate) {
			window.requestAnimationFrame(this.redraw.bind(this));
			this.willUpdate = true;
		}
	}

	redraw() {
		this.willUpdate = false;

		let ctx = this.domCanvas.getContext("2d");
		ctx.save();
		ctx.scale(this.pixel, this.pixel);
		ctx.clearRect(0, 0, this.domCanvas.width, this.domCanvas.height);
		this.canvas.draw(ctx, this.toolbar.currentTool);
		//const tool = this.toolbar.currentTool;
		this.toolbar.draw(ctx);
		ctx.restore();
	}

	/**
	 * Do a graphics calculation on 2D context
	 * @param {function} operation
	 * @return {*}
	 */
	calcInCanvas(operation) {
		let ctx = this.domCanvas.getContext("2d");
		ctx.save();
		const result = operation(ctx);
		ctx.restore();
		return result;
	}

	/**
	 * @return {Toolbar}
	 */
	createToolbar() {
		let toolbar = new Toolbar(this);
		return toolbar;
	}

	/**
	 * @return {Canvas}
	 */
	createCanvas() {
		throw "Abstract method createCanvas()";
	}

	zoomIn() {
		this.canvas.zoomIn();
		this.update();
	}

	zoomOut() {
		this.canvas.zoomOut();
		this.update();
	}

	newObject(type, x, y) {

	}

	toolChanged() {
	}
}